import { CallController } from '@gem/call/CallController/CallController';
import { Call } from '@gem/call/CallStore/Call';
import { PopupStore } from '@gem/popups';

import { INewRecordingFormValues } from './NewRecording/NewRecording.presenter';

export interface IStartRecordingPopupPresenter {
  onSuccess(data: INewRecordingFormValues): Promise<void>;
}

interface IStartRecordingPopupPresenterProps {
  popupInstance: PopupStore;
  call: Call;
  callController: CallController;
}

export function useStartRecordingPopupPresenter(
  props: IStartRecordingPopupPresenterProps
): IStartRecordingPopupPresenter {
  const onSuccess = async (data: INewRecordingFormValues): Promise<void> => {
    const call = props.call;

    if (!call) {
      return;
    }

    await props.callController.startRecording(data);
    props.popupInstance.close();
  };

  return {
    onSuccess,
  };
}
